import { Dispatch } from "redux";
import { EmployeeSalary } from "../../types/EmployeeSalary";
import {
  getSalaries,
  getSalaryById,
  createSalary,
  updateSalary,
  deleteSalary,
  getEmployeeSalaryByEmployeeId,
} from "../../services/EmployeeSalaryService";

/* ---------- Action Types ---------- */
export enum SalaryActionList {
  ADD_SALARY = "ADD_SALARY",
  EDIT_SALARY = "EDIT_SALARY",
  FETCH_SALARIES = "FETCH_SALARIES",
  DELETE_SALARY = "DELETE_SALARY",
  FETCH_SALARYS_EMPLOYEEID = "FETCH_SALARYS_EMPLOYEEID",
}

/* ---------- Action Interfaces ---------- */
export interface AddSalaryAction {
  type: SalaryActionList.ADD_SALARY;
  data: EmployeeSalary;
}

export interface EditSalaryAction {
  type: SalaryActionList.EDIT_SALARY;
  data: EmployeeSalary;
  id: number;
}

export interface FetchSalariesAction {
  type: SalaryActionList.FETCH_SALARIES;
  data: EmployeeSalary[];
}

export interface DeleteSalaryAction {
  type: SalaryActionList.DELETE_SALARY;
  data: number;
}

export interface FetchSalarysEmployeeId {
  type: SalaryActionList.FETCH_SALARYS_EMPLOYEEID;
  data: EmployeeSalary[];
}

/* ---------- Action Type Grouping ---------- */
export type SalaryActions =
  | AddSalaryAction
  | EditSalaryAction
  | FetchSalariesAction
  | DeleteSalaryAction
  | FetchSalarysEmployeeId;

/* ---------- Action Creators ---------- */
export const fetchSalariesAction = () => {
  return async (dispatch: Dispatch) => {
    const response = await getSalaries();

    dispatch<FetchSalariesAction>({
      type: SalaryActionList.FETCH_SALARIES,
      data: response,
    });
  };
};

export const addSalaryAction = (data: EmployeeSalary) => {
  return async (dispatch: Dispatch) => {
    return createSalary(data)
      .then((response) => {
        if (response.status === 200 && response.data.data) {
          dispatch<AddSalaryAction>({
            type: SalaryActionList.ADD_SALARY,
            data: response.data,
          });
          return Promise.resolve(
            response.data.message ?? "Employee Salary added",
          );
        } else {
          throw new Error(
            response.data?.message ?? "unable to employee Salary added",
          );
        }
      })
      .catch((error) =>
        Promise.reject(error.res?.data?.message ?? "Employee Salary deleted"),
      );
  };
};

export const editSalaryAction = (id: number, data: EmployeeSalary) => {
  return async (dispatch: Dispatch) => {
    return updateSalary(id, data)
      .then((response) => {
        if (response.status === 200 && response.data) {
          dispatch<EditSalaryAction>({
            type: SalaryActionList.EDIT_SALARY,
            data: response.data,
            id,
          });
          return Promise.resolve(
            response.data.message ?? "Employee Salary updated",
          );
        } else {
          throw new Error(
            response.data?.message ?? "unable to Employee Salary",
          );
        }
      })
      .catch((error) =>
        Promise.reject(
          error.response?.data?.message ?? "Employee Salary deleted",
        ),
      );
  };
};

export const deleteSalaryAction = (id: number) => {
  return async (dispatch: Dispatch) => {
    return deleteSalary(id)
      .then((response) => {
        if (response.status === 200) {
          dispatch<DeleteSalaryAction>({
            type: SalaryActionList.DELETE_SALARY,
            data: id,
          });
          return Promise.resolve(
            response.data.message ?? "Employee Salary deleted",
          );
        } else {
          throw { response };
        }
      })
      .catch((error) =>
        Promise.reject(
          error.response?.data?.message ?? "unable to delete Employee Salary",
        ),
      );
  };
};

export const fetchSalarysByEmployee =
  (employeeId: string, year: string, month: string) =>
  async (dispatch: Dispatch) => {
    try {
      const response = await getEmployeeSalaryByEmployeeId(
        employeeId,
        year,
        month,
      ); // Include month

      dispatch<FetchSalarysEmployeeId>({
        type: SalaryActionList.FETCH_SALARYS_EMPLOYEEID,
        data: response.data.data,
      });
    } catch (error) {
      console.error("Error fetching filtered Salarys", error);
    }
  };
